import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-tabla-view-maquinas',
  templateUrl: './tabla-view-maquinas.component.html',
  styleUrls: ['./tabla-view-maquinas.component.scss']
})
export class TablaViewMaquinasComponent implements OnInit {
  @Input() listaMaquinas: any[];

  headElements: string[];

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChangengOnChanges(changes: SimpleChanges): void {
    console.log('SE CARGO LISTA DE MAQUINAS');
    if (changes || changes.listaMaquinas) {
      this.headElements = ['Fila', 'Numero Placa', 'Errores'];
      this.listaMaquinas = changes.listaMaquinas.currentValue;
    }    
  }

}
